import { useRef, useState, useEffect } from "react";

import CoverWrapper from "@/components/molecules/mobile-quote-comparison/cover-wrapper/cover-wrapper";
import MobileQuoteComparisonTable from "@/components/molecules/mobile-quote-comparison/mobile-comparison-table/mobile-comparison-table";
import {
  ComparisonTableAreaContentType,
  CoverAreaDataType,
  CoverContentType,
  CancellationCovers,
} from "@/schema/quote-page/page.schema";

type QuoteSideDrawerProps = {
  selectedTab: string;
  drawerData: ComparisonTableAreaContentType;
  quoteAreaData?: CoverAreaDataType;
  onlineExclusiveBannerLabel?: string;
  selectedCoverLevel: string;
  updateCoverType: boolean;
  updateSelectedCoverLevel: (
    val: string,
    state: boolean,
    index: number
  ) => void;
  onSeeMoreDetails?: (index: number) => void;
  setCancellationCoverOpen?: (val: boolean) => void;
  setCancelltionChangeCoverType: (val: string) => void;
  setDynamicCoverLimit: (val: CancellationCovers[] | null) => void;
} & CoverContentType;

export function MobileQuoteComparison({
  selectedTab,
  drawerData,
  quoteAreaData,
  onlineExclusiveBannerLabel,
  selectedCoverLevel,
  updateCoverType,
  selectBtnLabel,
  updateSelectedCoverLevel,
  onSeeMoreDetails,
  setCancellationCoverOpen,
  setCancelltionChangeCoverType,
  setDynamicCoverLimit,
}: Readonly<QuoteSideDrawerProps>) {
  const detailsRef = useRef<HTMLDivElement | null>(null);
  const [firstSticky, setFirstSticky] = useState(true);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setFirstSticky(!entry.isIntersecting);
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -100% 0px",
      }
    );

    const currentRef = detailsRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <div className="pt-spacing-l">
      <CoverWrapper
        quoteAreaData={quoteAreaData}
        isSticky={firstSticky}
        onlineExclusiveBannerLabel={onlineExclusiveBannerLabel}
        selectedCoverLevel={selectedCoverLevel}
        updateCoverType={updateCoverType}
        cardTopData={{
          selectBtnInactiveLable: selectBtnLabel.notSelectedLabel,
          selectBtnActiveLable: selectBtnLabel.selectedLabel,
          // isLoading: false,
        }}
        onSelect={(val, state, index) =>
          updateSelectedCoverLevel(val, state, index)
        }
      />
      <MobileQuoteComparisonTable
        detailsRef={detailsRef}
        setCancelltionChangeCoverType={setCancelltionChangeCoverType}
        setDynamicCoverLimit={setDynamicCoverLimit}
        setCancellationCoverOpen={setCancellationCoverOpen}
        selectedTab={selectedTab}
        drawerData={drawerData}
        isMobileOnly
        onSeeMoreDetails={(index) => onSeeMoreDetails?.(index)}
      />
    </div>
  );
}
